import { TrackActions } from '@Actions/TrackActions';
import { IQueryData } from '@Reducers/common';
import { IConsultationType } from '@Reducers/consultation';
import { IClinicLocationsData, ISlot } from '@Reducers/schedule';
import { ISlotData } from '@Reducers/slot/types';
import { useAppDispatch, useAppSelector } from '@Redux/hooks';
import { getSessionId } from '@Utils/helper';
import dayjs from 'dayjs';
import { useCallback, useRef } from 'react';

const useTracking = (consultationType: IConsultationType, locationType: IClinicLocationsData) => {
  const dispatch = useAppDispatch();
  const queryData: IQueryData = useAppSelector((state) => state.common.queryData);
  const { slots }: { slots: ISlotData } = useAppSelector((state) => state.slot.actualSlots);
  const queryDataRef = useRef<IQueryData>(null);
  const consultationTypeRef = useRef<IConsultationType>(null);
  const locationTypeRef = useRef<IClinicLocationsData>(null);
  queryDataRef.current = queryData;
  consultationTypeRef.current = consultationType;
  locationTypeRef.current = locationType;
  const slotsRef = useRef<ISlotData>(null);
  slotsRef.current = slots;

  const trackSlots = useCallback(
    (eventName: string, selectedSlot: ISlot, flow: string) => {
      if (eventName && consultationTypeRef.current?.consultationTypeId) {
        dispatch(
          TrackActions.TrackSlots({
            eventName: eventName,
            providerIds: selectedSlot?.providerId ? [selectedSlot?.providerId] : queryDataRef.current?.providerId,
            excludedProviderIds: queryDataRef.current?.excludedProviderId,
            languages: queryDataRef.current.selectedLanguages,
            locationId: locationTypeRef.current?.id,
            consultationTypeId: consultationTypeRef.current?.consultationTypeId,
            slotTime: selectedSlot?.startDate ? dayjs(selectedSlot?.startDate)?.toISOString() : undefined,
            sessionId: getSessionId(),
            blockId: selectedSlot?.blockId,
            flow: flow,
            speciality: queryData?.speciality,
            slotsData: slotsRef.current,
          }),
        );
      }
    },
    [dispatch],
  );

  return trackSlots;
};

export default useTracking;
